module.exports = __webpack_public_path__ + "static/media/FacebookRound.51d33a52.svg";